// extracted by mini-css-extract-plugin
export default {"notificationWrapper":"_notifications_notificationWrapper__B+R-t","dotWrapper":"_notifications_dotWrapper__SQrBb"};